
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<template>
  <div class="mt-8 flex flex-col" v-if="load_data">
    <div class="table-first-container">
      <div class="table-second-container">
        <div class="table-third-container">
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.producer.name") }}
                </th>
                <th scope="col" class="table-header-cell">Rendimiento (Kg./ha)</th>
                <th scope="col" class="table-header-cell">Aceptado (Kg.)</th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                class="table-row"
                v-for="(producer, index) in producers"
                :key="index"
                >
                <td
                  class="table-cell link"
                  @click.prevent="goToShowProducer(producer)"
                  >
                  {{ producer.name }}
                </td>
                <td class="table-cell">{{ numberWithPrecision(producer.performance) }}</td>
                <td class="table-cell">{{ numberWithPrecision(producer.total_weight) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <loading-message v-else></loading-message>

  <table-paginator
    v-if="load_total"
    v-model="current_page"
    :total_rows="total_producers"
    :rows_per_page="rows_per_page"
    ></table-paginator>
</template>

<script>
import TablePaginator from "@/components/views/layout/TablePaginator.vue";
import Requester from "@/views/organization/requesters/production/query_by_producers/show_process.js";

export default {
  name: "OrgProductionQueryProducersShowProcessProducers",

  data() {
    return {
      current_page: 1,
      total_producers: 10,
      rows_per_page: 12,
      producers: [],
      load_data: false,
      load_total: false
    };
  },

  props: {
    organization_id: { required: true },
    harvest_process_id: { required: true },
  },

  components: { TablePaginator },

  created() {
    this.loadData();
  },

  methods: {
    goToShowProducer: function (producer) {
      this.$router.push({
        name: this.routeName("show_producer"),
        params: {
          organization_id: this.organization_id,
          harvest_process_id: this.harvest_process_id,
          producer_id: producer.id,
          provider_type: producer.type
        }
      });
    },

    fetchProducers: async function () {
      let response = await Requester.fetchProducers(
        this.organization_id,
        this.harvest_process_id,
        this.current_page,
        this.rows_per_page
      );
      this.producers = response.data;
      this.load_data = true;
    },

    fetchTotalProducers: async function () {
      let response = await Requester.fetchTotalProducers(
        this.organization_id,
        this.harvest_process_id
      );
      this.total_producers = response.data;
      this.load_total = true;
    },

    loadData: async function () {
      this.fetchTotalProducers();
      this.fetchProducers();
    }

  },

  watch: {
    current_page: async function () {
      this.load_data = false;
      await this.fetchProducers();
      this.load_data = true;
    }
  }
};
</script>
